import { mapGetters } from 'vuex';
import { TP_SERVER_DOMAIN } from "../utils/config";
export default {
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters(['blockchainList']),
  },
  methods: {
    /** 根据 address blockchain_id 获取行情代币详情 */
    async getSwapMarketClassOptional(data, utc_type) {
      this.isLoading = true;
      try {
        const response = await fetch(
          `${TP_SERVER_DOMAIN}/v1/swap_market/market_optional`,
          {
            method: 'post',
            body: JSON.stringify(data),
            headers: { os: 'web', utc_type }
          }
        );
        // console.log('response', response);
        const res = await response.json();
        if (res.result === 0 && res.data) {
          res.data.forEach((item) => {
            item.chg = (item.chg * 100).toFixed(2);
            item.price = this.parsePrice(item.price_usd)
            // item.volume = this.parseWithUnit(item.volume);
            this.setNetworkLogo(item);
            item.isEnter = false;
            if (item.network === 'APTOS' || item.network === 'SUI') {
              item.isMoveAddress = true
              item.moveAddress = item.address + '::' + item.bl_symbol
            }
          });
          // this.tokenList = res.data;
          return res.data;
        } 
        this.isLoading = false;
      } catch (error) {
        console.log(error);
        this.isLoading = false;
        // return [];
      }
    },
    /** 设置代币所属链的logo */
    setNetworkLogo(data) {
      const chain = this.blockchainList.filter(
        (b) => b.hid === data.blockchain_id
      );
      if (chain.length) {
        data.chain_icon = chain[0].icon;
      }
    },
  },
};
